import { useApplyEdition } from '@/pages/Apply/components/use-apply-edition';
import { Link } from '@inertiajs/react';
import { Button } from '@/components/ui/button';

interface Props {
  reason?: 'claimed' | 'invalid';
}

export function InviteNotFound({ reason = 'invalid' }: Props) {
  const { eventSlug } = useApplyEdition();
  const title =
    reason === 'claimed'
      ? 'Esta invitación ya fue usada'
      : 'Invitación inválida';
  const description =
    reason === 'claimed'
      ? 'Alguien ya completó su perfil con este link. Pídele al líder que te genere uno nuevo.'
      : 'El link no es válido o fue revocado. Pídele al líder del equipo que te lo reenvíe.';

  return (
    <div className="mx-auto max-w-md space-y-6 px-4 py-16 text-center">
      <h1 className="font-bold text-2xl uppercase tracking-wide">{title}</h1>
      <p className="text-muted-foreground">{description}</p>
      <Button asChild variant="outline">
        <Link href={`/${eventSlug}`}>Volver</Link>
      </Button>
    </div>
  );
}
